'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
function getFormattedCurrency(value, currency, culture, decimal) {
	var formattedCurrency = null;
	var noOfDecimal = decimal !== null && decimal !== undefined ? decimal : 2;

	if ((value || value === 0) && culture) {
		formattedCurrency = new Intl.NumberFormat(culture, { style: 'currency', currency: currency, maximumFractionDigits: noOfDecimal, minimumFractionDigits: noOfDecimal }).format(value);
	}

	return formattedCurrency;
}

exports.default = getFormattedCurrency;